// extracted by mini-css-extract-plugin
export var carrierIcon = "_tr-0";
export var carrierLogo = "_tr-1";
export var detailsSection = "_tr-2";